import DashboardPage from './dashboardPage';

export default DashboardPage;
